export default `
varying vec2 vUv;
uniform float dissipation;
uniform float falloff;
uniform float aspect;
uniform float alpha;
uniform vec2 mouse;
uniform vec2 velocity;
uniform sampler2D buffer;

void main() {
	vec4 color = texture2D(buffer, vUv) * dissipation;
	vec2 cursor = vUv - mouse;
	cursor.x *= aspect;
	vec3 stamp = vec3(velocity, 1.0 - pow(1.0 - min(1.0, length(velocity)), 3.0));
	float faOff = smoothstep(falloff, 0.0, length(cursor))*alpha;
	color.rgb = mix(color.rgb, stamp, vec3(faOff));
	gl_FragColor = color;
}
`
